import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
	return <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />;
});

export default function CusSnackbar({ message, severity, onClose }) {
	const [open, setOpen] = React.useState(false);

	React.useEffect(() => {
		setOpen(!!message);
	}, [message]);

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpen(false);
		if (onClose) {
			onClose();
		}
	};

	return (
		<Snackbar
			anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			open={open}
			autoHideDuration={6000}
			onClose={handleClose}
		>
			<Alert
				onClose={handleClose}
				severity={severity}
				sx={{
					width: '100%',
					...(severity === 'success' && { backgroundColor: '#5cb861' }),
					...(severity === 'error' && { backgroundColor: '#d84949' })
				}}
			>
				{message}
			</Alert>
		</Snackbar>
	);
}
